import { ReactElement } from 'react';

import { Checkbox, TableCell, TableHead, TableRow } from '@mui/material';
import { useTableCheckIds } from '../store';
import { useGetCredits } from '../hooks';

export const CreditsTableHead = (): ReactElement => {
  const checked = useTableCheckIds().length;
  const creditsQuery = useGetCredits();

  const handleSelectAll = () => {
    // console.log(creditsQuery.data?.data);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={checked > 0}
            onChange={handleSelectAll}
          />
        </TableCell>
        <TableCell>ID</TableCell>
        <TableCell>FULL NAME</TableCell>
        <TableCell>BALANCE</TableCell>
        <TableCell>EMAIL</TableCell>
        <TableCell>LAST ACTIVE DATE</TableCell>
        <TableCell>STATUS</TableCell>
        <TableCell>ACTIONS</TableCell>
      </TableRow>
    </TableHead>
  );
};
